import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { PageHeader } from "./PageHeader/PageHeader";

export const PageHeaderMenu = () => {
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeTab) {
      navigate(`/dedicated/passenger/pageheader/?activeTab=pageHeader`, {
        replace: true,
      });
    }
  }, [activeTab, navigate]);

  const tabItems = [
    {
      label: "Top Banner",
      key: "pageHeader",
      children: <PageHeader />,
    },
  ];

  const handleActionButton = (tabKey: string) => {
    if (tabKey === "pageHeader") {
      return (
        <Button
          onClick={() =>
            navigate("/dedicated/passenger/pageheader/pageheader/add")
          }
          icon={<Icon icon="lucide:plus" />}
        >
          Add Page Header
        </Button>
      );
    }
    return null;
  };

  return (
    <ContentWrapper
      title="Page Header"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleActionButton(activeTab || "pageHeader")}
    >
      <Tabs
        activeKey={activeTab || "pageHeader"}
        items={tabItems}
        onChange={(key) =>
          navigate(`${window.location.pathname}?activeTab=${key}`)
        }
      />
    </ContentWrapper>
  );
};
